import { useDispatch, useSelector } from "react-redux";

import { useGetSettings } from "@/api/configuration/useConfigurationAPI";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { RootState } from "@/store";
import { setShowDrawLimitInfo } from "@/store/slice/uiSlice";

import { Button } from "../ui/button";

export default function DrawLimitInfo() {
  const dispatch = useDispatch();

  const { showDrawLimitInfo, isDrawPolygon } = useSelector(
    (state: RootState) => state.ui
  );

  const { data } = useGetSettings();

  return (
    <Dialog
      open={isDrawPolygon && showDrawLimitInfo}
      onOpenChange={() => dispatch(setShowDrawLimitInfo(false))}
    >
      <DialogContent isHideClose>
        <DialogHeader>
          <DialogTitle className="sr-only">Reach Max Polygon</DialogTitle>
        </DialogHeader>
        <h1 className="text-center text-xl font-semibold text-txtHeading -mt-4">
          Reach Max Polygon
        </h1>
        <DialogDescription className="text-sm text-txtBody text-center">
          Cannot save, the current limit is {data?.max_catchments}, please
          delete one first.
        </DialogDescription>
        <Button onClick={() => dispatch(setShowDrawLimitInfo(false))}>
          OK
        </Button>
      </DialogContent>
    </Dialog>
  );
}
